import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useParams, useLocation } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { ContactPage } from "./pages/ContactPage";
import { B2BPage } from "./pages/B2BPage";
import { JournalPage } from "./pages/JournalPage";
import { AboutPage } from "./pages/AboutPage";
import { IndonesiaJourneysPage } from "./pages/IndonesiaJourneysPage";
import { IndonesiaGeographicGroupPage } from "./pages/IndonesiaGeographicGroupPage";
import { CollectionsPage } from "./pages/CollectionsPage";
import { WorldwideJourneysPage } from "./pages/WorldwideJourneysPage";
import { WorldwideContinentPage } from "./pages/WorldwideContinentPage";
import { WorldwideRegionPage } from "./pages/WorldwideRegionPage";
import { WorldwideDestinationPage } from "./pages/WorldwideDestinationPage";
import { NepalTourPage } from "./pages/NepalTourPage";
import { BhutanTourPage } from "./pages/BhutanTourPage";
import { BhutanFamTripPage } from "./pages/BhutanFamTripPage";
import { FamTripHubPage } from "./pages/FamTripHubPage";
import { ShanghaiCruisePage } from "./pages/ShanghaiCruisePage";
import { CoffeeTourPage } from "./pages/CoffeeTourPage";
import { CoffeeCivilizationPage } from "./pages/CoffeeCivilizationPage";
import { BaliLuxuryPage } from "./pages/BaliLuxuryPage";
import { KomodoTourPage } from "./pages/KomodoTourPage";

// B2B Portal Pages
import { B2BLandingPage } from "./pages/B2BLandingPage";
import { B2BRegisterPage } from "./pages/B2BRegisterPage";
import { B2BLoginPage } from "./pages/B2BLoginPage";
import { B2BPortalPage } from "./pages/B2BPortalPage";
import { AdminB2BDashboard } from "./pages/AdminB2BDashboard";

// Admin Portal Pages
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import { AdminProtectedRoute } from "./components/AdminProtectedRoute";
import { AdminLoginPage } from "./pages/AdminLoginPage";
import { AdminDashboardPage } from "./pages/AdminDashboardPage";
import { AdminCostingListPage } from "./pages/AdminCostingListPage";
import { AdminCostingFormPage } from "./pages/AdminCostingFormPage";
import { AdminProjectListPage } from "./pages/AdminProjectListPage";
import { AdminProjectDetailPage } from "./pages/AdminProjectDetailPage";

import { TourDetailPage } from "./components/TourDetailPage";
import { allTours } from "./data/tours";
function GenericTourDetailPage() {
  const { tourId } = useParams();
  const tour = allTours.find((item) => item.id === tourId);

  return <TourDetailPage tour={tour} />;
}
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
function App() {
  return (
    <div className="App">
      <AdminAuthProvider>
        <BrowserRouter>
        <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/journal" element={<JournalPage />} />
            <Route path="/about" element={<AboutPage />} />
            
            {/* B2B Portal Routes */}
            <Route path="/b2b" element={<B2BLandingPage />} />
            <Route path="/b2b/register" element={<B2BRegisterPage />} />
            <Route path="/b2b/login" element={<B2BLoginPage />} />
            <Route path="/b2b/portal" element={<B2BPortalPage />} />
            
            {/* Old Admin Routes */}
            <Route path="/admin/b2b-requests" element={<AdminProtectedRoute><AdminB2BDashboard /></AdminProtectedRoute>} />
            
            {/* New Admin Portal Routes */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminProtectedRoute><AdminDashboardPage /></AdminProtectedRoute>} />
            <Route path="/admin/costing" element={<AdminProtectedRoute><AdminCostingListPage /></AdminProtectedRoute>} />
            <Route path="/admin/costing/new" element={<AdminProtectedRoute><AdminCostingFormPage /></AdminProtectedRoute>} />
            <Route path="/admin/costing/:id" element={<AdminProtectedRoute><AdminCostingFormPage /></AdminProtectedRoute>} />
            <Route path="/admin/projects" element={<AdminProtectedRoute><AdminProjectListPage /></AdminProtectedRoute>} />
            <Route path="/admin/projects/:id" element={<AdminProtectedRoute><AdminProjectDetailPage /></AdminProtectedRoute>} />
            
            {/* Special Pages */}
            <Route path="/CoffeeCivilization" element={<CoffeeCivilizationPage />} />
            
            {/* Journey Catalog Pages */}
            <Route path="/indonesia-journeys" element={<IndonesiaJourneysPage />} />
            <Route path="/indonesia-journeys/:groupId" element={<IndonesiaGeographicGroupPage />} />
            <Route path="/collections" element={<CollectionsPage />} />
            <Route path="/worldwide-journeys" element={<WorldwideJourneysPage />} />
            <Route path="/worldwide-journeys/:continentId/:regionId/:destinationId" element={<WorldwideDestinationPage />} />
            <Route path="/worldwide-journeys/:continentId/:regionId" element={<WorldwideRegionPage />} />
            <Route path="/worldwide-journeys/:continentId" element={<WorldwideContinentPage />} />
          
          {/* Legacy region URLs for backward compatibility */}
          <Route path="/worldwide-journeys/:regionId/:destinationId" element={<WorldwideDestinationPage />} />
          
          {/* Tour Detail Pages - Worldwide */}
          <Route path="/tours/nepal-spiritual-journey" element={<NepalTourPage />} />
          <Route path="/tours/bhutan-festival-journey" element={<BhutanTourPage />} />
          <Route path="/tours/shanghai-cruise" element={<ShanghaiCruisePage />} />
          
          {/* FAM Trip Pages */}
          <Route path="/famtrip" element={<FamTripHubPage />} />
          <Route path="/famtrip/bhutan-druk-wangyel-festival-2026" element={<BhutanFamTripPage />} />
          
          {/* Tour Detail Pages - Indonesia */}
          <Route path="/tours/coffee-civilization" element={<CoffeeTourPage />} />
          <Route path="/tours/bali-luxury-retreat" element={<BaliLuxuryPage />} />
          <Route path="/tours/komodo-liveaboard" element={<KomodoTourPage />} />
          <Route path="/tours/:tourId" element={<GenericTourDetailPage />} />
          {/* Legacy routes */}
          <Route path="/collections" element={<IndonesiaJourneysPage />} />
          <Route path="/destinations" element={<IndonesiaJourneysPage />} />
        </Routes>
      </BrowserRouter>
      </AdminAuthProvider>
    </div>
  );
}

export default App;
